export default "__VITE_ASSET__BLU3Ty1E__"